import GoogleLogin from 'vue3-google-login';

export default defineNuxtPlugin(({ vueApp }) => {
    const config = useRuntimeConfig();

    vueApp.use(GoogleLogin, {
        clientId: config.public.googleAuthClientId,
    })
})